// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound-module__wrapper___efnpk"};